import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { onUnexpectedError } from '../../../base/common/errors.js';
import { Emitter } from '../../../base/common/event.js';
import { Disposable } from '../../../base/common/lifecycle.js';
import * as mime from '../../../base/common/mime.js';
import * as strings from '../../../base/common/strings.js';
import { LanguageIdentifier } from '../modes.js';
import { ModesRegistry } from '../modes/modesRegistry.js';
import { NULL_LANGUAGE_IDENTIFIER, NULL_MODE_ID } from '../modes/nullMode.js';
import { Extensions } from '../../../platform/configuration/common/configurationRegistry.js';
import { Registry } from '../../../platform/registry/common/platform.js';
var hasOwnProperty = Object.prototype.hasOwnProperty;
export var LanguagesRegistry = /*#__PURE__*/function (_Disposable) {
  _inherits(LanguagesRegistry, _Disposable);

  var _super = _createSuper(LanguagesRegistry);

  function LanguagesRegistry() {
    var _this;

    var useModesRegistry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var warnOnOverwrite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, LanguagesRegistry);

    _this = _super.call(this);
    _this._onDidChange = _this._register(new Emitter());
    _this.onDidChange = _this._onDidChange.event;
    _this._warnOnOverwrite = warnOnOverwrite;
    _this._nextLanguageId2 = 1;
    _this._languageIdToLanguage = [];
    _this._languageToLanguageId = Object.create(null);
    _this._languages = {};
    _this._mimeTypesMap = {};
    _this._nameMap = {};
    _this._lowercaseNameMap = {};

    if (useModesRegistry) {
      _this._initializeFromRegistry();

      _this._register(ModesRegistry.onDidChangeLanguages(function (m) {
        return _this._initializeFromRegistry();
      }));
    }

    return _this;
  }

  _createClass(LanguagesRegistry, [{
    key: "_initializeFromRegistry",
    value: function _initializeFromRegistry() {
      this._languages = {};
      this._mimeTypesMap = {};
      this._nameMap = {};
      this._lowercaseNameMap = {};
      var desc = ModesRegistry.getLanguages();

      this._registerLanguages(desc);
    }
  }, {
    key: "_registerLanguages",
    value: function _registerLanguages(desc) {
      var _this2 = this;

      var _iterator = _createForOfIteratorHelper(desc),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var d = _step.value;

          this._registerLanguage(d);
        } // Rebuild fast path maps

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._mimeTypesMap = {};
      this._nameMap = {};
      this._lowercaseNameMap = {};
      Object.keys(this._languages).forEach(function (langId) {
        var language = _this2._languages[langId];

        if (language.name) {
          _this2._nameMap[language.name] = language.identifier;
        }

        language.aliases.forEach(function (alias) {
          _this2._lowercaseNameMap[alias.toLowerCase()] = language.identifier;
        });
        language.mimetypes.forEach(function (mimetype) {
          _this2._mimeTypesMap[mimetype] = language.identifier;
        });
      });
      Registry.as(Extensions.Configuration).registerOverrideIdentifiers(ModesRegistry.getLanguages().map(function (language) {
        return language.id;
      }));

      this._onDidChange.fire();
    }
  }, {
    key: "_getLanguageId",
    value: function _getLanguageId(language) {
      if (this._languageToLanguageId[language]) {
        return this._languageToLanguageId[language];
      }

      var languageId = this._nextLanguageId2++;
      this._languageIdToLanguage[languageId] = language;
      this._languageToLanguageId[language] = languageId;
      return languageId;
    }
  }, {
    key: "_registerLanguage",
    value: function _registerLanguage(lang) {
      var langId = lang.id;
      var resolvedLanguage;

      if (hasOwnProperty.call(this._languages, langId)) {
        resolvedLanguage = this._languages[langId];
      } else {
        var languageId = this._getLanguageId(langId);

        resolvedLanguage = {
          identifier: new LanguageIdentifier(langId, languageId),
          name: null,
          mimetypes: [],
          aliases: [],
          extensions: [],
          filenames: [],
          configurationFiles: []
        };
        this._languages[langId] = resolvedLanguage;
      }

      this._mergeLanguage(resolvedLanguage, lang);
    }
  }, {
    key: "_mergeLanguage",
    value: function _mergeLanguage(resolvedLanguage, lang) {
      var langId = lang.id;
      var primaryMime = null;

      if (Array.isArray(lang.mimetypes) && lang.mimetypes.length > 0) {
        var _resolvedLanguage$mim;

        (_resolvedLanguage$mim = resolvedLanguage.mimetypes).push.apply(_resolvedLanguage$mim, _toConsumableArray(lang.mimetypes));

        primaryMime = lang.mimetypes[0];
      }

      if (!primaryMime) {
        primaryMime = "text/x-".concat(langId);
        resolvedLanguage.mimetypes.push(primaryMime);
      }

      if (Array.isArray(lang.extensions)) {
        if (lang.configuration) {
          // insert first as this appears to be the 'primary' language definition
          resolvedLanguage.extensions = lang.extensions.concat(resolvedLanguage.extensions);
        } else {
          resolvedLanguage.extensions = resolvedLanguage.extensions.concat(lang.extensions);
        }

        var _iterator2 = _createForOfIteratorHelper(lang.extensions),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var extension = _step2.value;
            mime.registerTextMime({
              id: langId,
              mime: primaryMime,
              extension: extension
            }, this._warnOnOverwrite);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      if (Array.isArray(lang.filenames)) {
        var _iterator3 = _createForOfIteratorHelper(lang.filenames),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var filename = _step3.value;
            mime.registerTextMime({
              id: langId,
              mime: primaryMime,
              filename: filename
            }, this._warnOnOverwrite);
            resolvedLanguage.filenames.push(filename);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }

      if (Array.isArray(lang.filenamePatterns)) {
        var _iterator4 = _createForOfIteratorHelper(lang.filenamePatterns),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var filenamePattern = _step4.value;
            mime.registerTextMime({
              id: langId,
              mime: primaryMime,
              filepattern: filenamePattern
            }, this._warnOnOverwrite);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }

      if (typeof lang.firstLine === 'string' && lang.firstLine.length > 0) {
        var firstLineRegexStr = lang.firstLine;

        if (firstLineRegexStr.charAt(0) !== '^') {
          firstLineRegexStr = '^' + firstLineRegexStr;
        }

        try {
          var firstLineRegex = new RegExp(firstLineRegexStr);

          if (!strings.regExpLeadsToEndlessLoop(firstLineRegex)) {
            mime.registerTextMime({
              id: langId,
              mime: primaryMime,
              firstline: firstLineRegex
            }, this._warnOnOverwrite);
          }
        } catch (err) {
          // Most likely, the regex was bad
          onUnexpectedError(err);
        }
      }

      resolvedLanguage.aliases.push(langId);
      var langAliases = null;

      if (typeof lang.aliases !== 'undefined' && Array.isArray(lang.aliases)) {
        if (lang.aliases.length === 0) {
          // signal that this language should not get a name
          langAliases = [null];
        } else {
          langAliases = lang.aliases;
        }
      }

      if (langAliases !== null) {
        var _iterator5 = _createForOfIteratorHelper(langAliases),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var langAlias = _step5.value;

            if (!langAlias || langAlias.length === 0) {
              continue;
            }

            resolvedLanguage.aliases.push(langAlias);
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      var containsAliases = langAliases !== null && langAliases.length > 0;

      if (containsAliases && langAliases[0] === null) {// signal that this language should not get a name
      } else {
        var bestName = (containsAliases ? langAliases[0] : null) || langId;

        if (containsAliases || !resolvedLanguage.name) {
          resolvedLanguage.name = bestName;
        }
      }

      if (lang.configuration) {
        resolvedLanguage.configurationFiles.push(lang.configuration);
      }
    }
  }, {
    key: "isRegisteredMode",
    value: function isRegisteredMode(mimetypeOrModeId) {
      // Is this a known mime type ?
      if (hasOwnProperty.call(this._mimeTypesMap, mimetypeOrModeId)) {
        return true;
      } // Is this a known mode id ?


      return hasOwnProperty.call(this._languages, mimetypeOrModeId);
    }
  }, {
    key: "getModeIdForLanguageNameLowercase",
    value: function getModeIdForLanguageNameLowercase(languageNameLower) {
      if (!hasOwnProperty.call(this._lowercaseNameMap, languageNameLower)) {
        return null;
      }

      return this._lowercaseNameMap[languageNameLower].language;
    }
  }, {
    key: "extractModeIds",
    value: function extractModeIds(commaSeparatedMimetypesOrCommaSeparatedIds) {
      var _this3 = this;

      if (!commaSeparatedMimetypesOrCommaSeparatedIds) {
        return [];
      }

      return commaSeparatedMimetypesOrCommaSeparatedIds.split(',').map(function (mimeTypeOrId) {
        return mimeTypeOrId.trim();
      }).map(function (mimeTypeOrId) {
        if (hasOwnProperty.call(_this3._mimeTypesMap, mimeTypeOrId)) {
          return _this3._mimeTypesMap[mimeTypeOrId].language;
        }

        return mimeTypeOrId;
      }).filter(function (modeId) {
        return hasOwnProperty.call(_this3._languages, modeId);
      });
    }
  }, {
    key: "getLanguageIdentifier",
    value: function getLanguageIdentifier(_modeId) {
      if (_modeId === NULL_MODE_ID || _modeId === 0
      /* Null */
      ) {
        return NULL_LANGUAGE_IDENTIFIER;
      }

      var modeId;

      if (typeof _modeId === 'string') {
        modeId = _modeId;
      } else {
        modeId = this._languageIdToLanguage[_modeId];

        if (!modeId) {
          return null;
        }
      }

      if (!hasOwnProperty.call(this._languages, modeId)) {
        return null;
      }

      return this._languages[modeId].identifier;
    }
  }, {
    key: "getModeIdsFromFilepathOrFirstLine",
    value: function getModeIdsFromFilepathOrFirstLine(resource, firstLine) {
      if (!resource && !firstLine) {
        return [];
      }

      var mimeTypes = mime.guessMimeTypes(resource, firstLine);
      return this.extractModeIds(mimeTypes.join(','));
    }
  }]);

  return LanguagesRegistry;
}(Disposable);